import { getObjectUtil } from 'packages/src'
import { MODEL_KEY } from '../../../model/constants'

import { getValueReduxUtil } from '../get-value'

function getUpdatedAtReduxUtil (instance) {
  return (
    getValueReduxUtil(instance, MODEL_KEY.UPDATED_AT) ||
    getObjectUtil(instance, MODEL_KEY.UPDATED_AT)
  )
}

export default getUpdatedAtReduxUtil
